module.exports = __webpack_public_path__ + "img/withdrawn-icon.9739ee12.svg";